import { render, staticRenderFns } from "./PeriodSectionCard.vue?vue&type=template&id=2cfe43dd&scoped=true&"
import script from "./PeriodSectionCard.vue?vue&type=script&lang=ts&"
export * from "./PeriodSectionCard.vue?vue&type=script&lang=ts&"
import style0 from "./PeriodSectionCard.vue?vue&type=style&index=0&id=2cfe43dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfe43dd",
  null
  
)

export default component.exports